import React from 'react';
import { EllipsisHorizontalIcon } from '@heroicons/react/24/outline';
import { Menu } from '@teetsh/app/src/components/Menu';
import { useTranslation } from 'react-i18next';
import { BreadcrumbItem } from './index';

interface HomeConfig {
  to?: string;
  onClick?: () => void;
  icon?: React.ReactNode | (() => React.ReactNode);
  text?: string;
  ariaLabel?: string;
  alwaysShowText?: boolean;
}

interface Props {
  home?: HomeConfig;
  overflowItems: BreadcrumbItem[];
}

export function BreadcrumbOverflowMenu({ home, overflowItems }: Props) {
  const { t } = useTranslation();

  return (
    <Menu>
      <Menu.Button minimal tw="px-0">
        <EllipsisHorizontalIcon tw="h-5 w-5" />
      </Menu.Button>
      <Menu.Items>
        {home?.to && (
          <Menu.Item
            onClick={() => {
              if (home.onClick) home.onClick();
              else if (home.to) window.location.href = home.to;
            }}
            text={home.text || t('common:home')}
            icon={
              typeof home.icon === 'function'
                ? home.icon
                : ((() => home.icon) as any)
            }
          />
        )}
        {overflowItems.map(item => (
          <Menu.Item
            key={item.id}
            onClick={item.onClick}
            icon={
              typeof item.icon === 'function'
                ? item.icon
                : ((() => item.icon) as any)
            }
            text={typeof item.text === 'string' ? item.text : ''}
          />
        ))}
      </Menu.Items>
    </Menu>
  );
}
